import fetchClient from "api/client";
import CAMPAIGNS_ENDPOINT from "./campaignsEndpoint";

/**
 * @description PATCH /api/campaigns/rules/:ruleId
 * @param {object} payload - The payload object.
 * @param {number|string} payload.ruleId - The ID of the rule to update.
 * @param {object} payload.body - The body to update on the rule.
 * @returns {Promise}
 */
export default function updatePhaseRule({ ruleId, body }) {
  if (!ruleId) {
    return Promise.reject(new Error("Rule ID is required for updating."));
  }

  const url = `${CAMPAIGNS_ENDPOINT}/rules/${ruleId}`;

  return fetchClient.patch(url, { body });
}
